/* eslint-disable react-hooks/exhaustive-deps */
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormHelperText,
  Grid,
  List,
  ListItem,
  MenuItem,
  OutlinedInput,
  Popover,
  Select,
  Stack,
  styled,
  SvgIconTypeMap,
  TextField,
  Typography,
  useTheme
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { TSocialMedia } from 'src/models/general';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedinIcon from '@mui/icons-material/LinkedIn';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { IObjectInput } from 'src/models/objectManagement';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import {
  reducerUpdateSelectedTempKeywordHashtag,
  reducerUpdateTempKeywordOrHashtag
} from 'src/features/objectManagement';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoFilledIcon from '@mui/icons-material/Info';
import languages from './languages';
import { themeColors } from 'src/theme/schemes/PureLightTheme';
import { withStyles } from '@mui/styles';
import { generateRandomString } from 'src/utils/generateRandomString';
import { useAlert } from 'src/hooks/useAlert';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import TiktokIcon from 'src/components/TikTokIcon/TikTokIcon';
import ThreadsIcon from 'src/components/Threads/ThreadsIcon';
import GetSocialMediaIcon from 'src/components/GetSocialMediaIcon';
import {
  regexAllLanguagesExceptDoubleQuote,
  regexWordWrappedInsideDoubleQuote
} from 'src/constants';
import Information from 'src/components/Information';

interface ISocialMedia {
  id: TSocialMedia;
  label: string;
  icon:
    | (OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & {
        muiName: string;
      })
    | any;
  disabled: boolean;
}

interface ITypeInput {
  id: 'keyword' | 'hashtag';
  label: string;
  isActive: boolean;
  value: string;
}

const CustomButton = styled(Button)(
  ({ theme }) => `
    border: unset;
    border-radius: 6px;
    background-color: white;
    border: 1px solid ${theme.palette.divider};
    border-color: ${theme.palette.common.black}
    color: ${theme.palette.primary.main};
    &:hover{
      background-color: ${theme.palette.grey[300]};
    }
    width: 35%;
  `
);

const ButtonInputType = styled(Button)(
  ({ theme }) => `
        background: ${theme.palette.common.black};
        height: 22.61px;

      `
);

const ButtonInputTypeInactive = styled(Button)(
  ({ theme }) => `
    height: 22.61px;
    &:hover {
        background-color: unset;
    }
    `
);

const CustomAutocomplete = withStyles({
  inputRoot: {
    '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"] .MuiAutocomplete-input':
      {
        padding: 0
      }
  }
})((props: any) => <Autocomplete {...props} />);

const listOptionSocialMedia: Array<ISocialMedia> = [
  {
    id: 'twitter',
    label: 'X',
    icon: TwitterIcon,
    disabled: false
  },
  {
    id: 'facebook',
    label: 'Facebook',
    icon: FacebookIcon,
    disabled: false
  },
  {
    id: 'instagram',
    label: 'Instagram',
    icon: InstagramIcon,
    disabled: false
  },
  {
    id: 'youtube',
    label: 'Youtube',
    icon: YouTubeIcon,
    disabled: false
  },
  {
    id: 'tiktok',
    label: 'TikTok',
    icon: TiktokIcon,
    disabled: false
  },
  {
    id: 'threads',
    label: 'Threads',
    icon: ThreadsIcon,
    disabled: false
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
    icon: LinkedinIcon,
    disabled: false
  }
];

const AddKeywordOrHastagRetail = ({
  streamType
}: {
  streamType: 'keyword' | 'hashtag' | null;
}) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();

  const { handleClickAlert } = useAlert();

  const { tempInputKeywordOrHashtag } = useAppSelector(
    (state) => state.objectManagement
  );
  const project = useAppSelector((state) => state.users.project);

  const [isExpandFilter, setIsExpandFilter] = useState<boolean>(false);

  const isKeywordHashtagAlreadyExistCreate = (
    stringifiedInsertedValue: string[]
  ) => {
    const stringifiedTempKeywordHashtag = tempInputKeywordOrHashtag.map(
      (item) => {
        const { id, ...rest } = item;
        return JSON.stringify(rest);
      }
    );

    const findExistKeywordHashtag = stringifiedTempKeywordHashtag.map(
      (item) => {
        if (stringifiedInsertedValue.includes(item)) {
          return true;
        }
        return false;
      }
    );

    if (findExistKeywordHashtag.includes(true)) {
      return true;
    } else {
      return false;
    }
  };

  const defaultSocmed: TSocialMedia[] = listOptionSocialMedia.map(
    (item) => item.id
  );

  const [socialMedia, setSocialMedia] = useState<TSocialMedia[]>(defaultSocmed);
  function validationSchema() {
    return Yup.object({
      objectName: Yup.string()
        .required()
        .min(3, ' Phrase must contain at least three characters.')
        .matches(
          regexAllLanguagesExceptDoubleQuote,
          ' Phrase must not contain symbols.'
        )
        .matches(
          regexWordWrappedInsideDoubleQuote,
          ' Phrase must be either wrapped inside double quote or not wrapped at all.'
        ),
      includes: Yup.array().of(
        Yup.string()
          .min(2, ' Phrase must contain at least two characters.')
          .matches(
            regexAllLanguagesExceptDoubleQuote,
            ' Phrase must not contain symbols.'
          )
          .matches(
            regexWordWrappedInsideDoubleQuote,
            ' Phrase must be either wrapped inside double quote or not wrapped at all.'
          )
      ),
      excludes: Yup.array().of(
        Yup.string()
          .min(2, ' Phrase must contain at least two characters.')
          .matches(
            regexAllLanguagesExceptDoubleQuote,
            ' Phrase must not contain symbols.'
          )
          .matches(
            regexWordWrappedInsideDoubleQuote,
            ' Phrase must be either wrapped inside double quote or not wrapped at all.'
          )
      )
    });
  }
  const {
    handleChange,
    setFieldValue,
    errors,
    touched,
    values,
    setFieldTouched,
    setSubmitting
  } = useFormik<IObjectInput>({
    initialValues: {
      content: '',
      displayPic: '',
      excludes: [],
      extraContent: '',
      includes: [],
      isHashtag: false,
      languages: 'id',
      objectName: '',
      socialMedia: null,
      streamType: 'keyword'
    },
    validationSchema: validationSchema(),
    onSubmit: () => {}
  });

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const [inputType, setInputType] = useState<Array<ITypeInput>>([
    { id: 'keyword', isActive: true, label: 'Keyword', value: 'keyword' },
    { id: 'hashtag', isActive: false, label: 'Hashtag', value: 'hashtag' }
  ]);

  const handleChangeInputType = (id: string) => {
    setInputType((prevPeriodes) =>
      prevPeriodes.map((period) => {
        if (period.id === id) return { ...period, isActive: true };
        return { ...period, isActive: false };
      })
    );
    setFieldValue('streamType', id);
  };

  const objectType: 'keyword' | 'hashtag' = inputType[0].isActive
    ? inputType[0].id
    : inputType[1].id;

  const handleIncludesLocal = (value: string[]) => {
    setFieldTouched('includes', true);
    setFieldValue('includes', value);
  };

  const handleExcludesLocal = (value: string[]) => {
    setFieldTouched('excludes', true);
    setFieldValue('excludes', value);
  };

  const handleClear = () => {
    setFieldValue('content', '');
    setFieldValue('displayPic', '');
    setFieldValue('excludes', []);
    setFieldValue('extraContent', '');
    setFieldValue('includes', []);
    setFieldValue('isHashtag', false);
    setFieldValue('languages', 'id');
    setFieldValue('objectName', '');
    setFieldValue('socialMedia', null);
    setFieldValue('streamType', 'keyword');
    setSocialMedia(defaultSocmed);
    dispatch(reducerUpdateSelectedTempKeywordHashtag(null));
  };

  const handleSaveKeywordHashtag = () => {
    const isQuotaFull =
      tempInputKeywordOrHashtag.length + socialMedia.length >
      project.onBoarding.advanceObjectQuota;
    if (isQuotaFull) {
      handleClickAlert({
        horizontal: 'center',
        vertical: 'top',
        message:
          'Your keyword & hashtag quota is full. Remove an existing keyword or hashtag to add a new one.',
        severity: 'error'
      });
      return;
    }

    //keyword hashtag exist alert
    const insertedValue = socialMedia.map((item) => {
      return JSON.stringify({
        ...values,
        content: values.objectName,
        socialMedia: item
      });
    });
    if (isKeywordHashtagAlreadyExistCreate(insertedValue)) {
      handleClickAlert({
        horizontal: 'center',
        vertical: 'top',
        message: 'The keyword or hashtag already exists.',
        severity: 'error'
      });
      return;
    }
    const createdTempKeywordHashtag = socialMedia.map((item) => {
      return {
        ...values,
        id: generateRandomString(),
        content: values.objectName,
        socialMedia: item
      };
    });

    dispatch(reducerUpdateTempKeywordOrHashtag(createdTempKeywordHashtag));

    handleClear();
    setSubmitting(false);
  };

  useEffect(() => {
    if (objectType === inputType[0].id) {
      setFieldValue('isHashtag', false);
      return;
    }
    setFieldValue('isHashtag', true);
  }, [inputType]);

  const getObjectTypeSymbol = (isHashtag: boolean) => {
    if (isHashtag) return '#';
    return '~';
  };

  const isDisableSubmit = socialMedia.length === 0 || !values.objectName;

  const labelDropdown = useMemo(() => {
    const getFirstSocmedName =
      listOptionSocialMedia.find((item) => item.id === socialMedia[0])?.label ??
      '';
    const plusLabel = socialMedia.length - 1;
    return getFirstSocmedName + (plusLabel > 0 ? ` + ${plusLabel}` : '');
  }, [socialMedia]);

  useEffect(() => {
    if (!streamType) return;
    handleChangeInputType(streamType);
  }, [streamType]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography fontWeight={700} fontSize="13px">
            Enter Keyword or Hashtag
          </Typography>
          <Information
            content={
              <p>
                Keyword or Hashtag must be{' '}
                <strong>at least three characters</strong> and{' '}
                <strong>cannot contain symbols</strong>
                (e.g., ; , {} , [] , ? , / , \ , |). Use
                <strong> quotation marks </strong>
                (" ") for <strong>precise keyword</strong> matching.
              </p>
            }
          />
        </Stack>
        <Box
          sx={{
            height: theme.spacing(4),
            width: '162px',
            background: '#F5F5F5',
            borderRadius: '100px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '5px 6px 5px 6px'
          }}
        >
          <Grid container>
            {inputType.map(({ id, label, isActive }) => {
              if (isActive)
                return (
                  <Grid
                    item
                    sm={6}
                    key={id}
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <ButtonInputType variant="contained" fullWidth>
                      {label}
                    </ButtonInputType>
                  </Grid>
                );
              return (
                <Grid item sm={6} key={id}>
                  <ButtonInputTypeInactive
                    variant="text"
                    fullWidth
                    onClick={
                      streamType === null
                        ? () => handleChangeInputType(id)
                        : undefined
                    }
                    disabled={streamType !== null}
                  >
                    {label}
                  </ButtonInputTypeInactive>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Stack>
      <Stack direction="row" spacing={1}>
        <CustomButton
          variant="contained"
          onClick={handleClick}
          startIcon={
            <GetSocialMediaIcon
              socialMedia={socialMedia[0]}
              fontSize="small"
              sx={{ color: themeColors.black }}
            />
          }
          endIcon={<ArrowDropDownIcon fontSize="small" color="primary" />}
        >
          <Typography
            variant="subtitle1"
            color="black"
            sx={{
              fontWeight: 600,
              color: '#051C26'
            }}
            width="100%"
          >
            {labelDropdown}
          </Typography>
        </CustomButton>
        <FormControl fullWidth size="medium">
          <OutlinedInput
            name="objectName"
            onChange={(e) => {
              handleChange(e);
            }}
            value={values.objectName}
            startAdornment={
              <Typography sx={{ ml: '4px' }}>
                {getObjectTypeSymbol(values.isHashtag)}
              </Typography>
            }
          />
          <FormHelperText
            error
            variant="outlined"
            margin="dense"
            sx={{ ml: 0 }}
          >
            {errors.objectName && values.objectName && errors.objectName}
          </FormHelperText>
        </FormControl>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <InfoFilledIcon sx={{ fontSize: '14px' }} />
        <Typography color="#757575" fontSize="12px">
          Use quotation marks (“ ”) to search for the exact phrase. Without
          quotation marks, each word will be tracked separately and may return
          unrelated results.
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {/* TODO: Suggested */}
        <Stack></Stack>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            alignItems: 'center',
            backgroundColor: theme.colors.primary.light,
            padding: 1,
            borderRadius: '16px',
            cursor: 'pointer'
          }}
          onClick={() => setIsExpandFilter(!isExpandFilter)}
        >
          <FilterAltOutlinedIcon color="primary" fontSize="small" />
          <Typography color={theme.colors.primary.main} fontSize="14px">
            Filter
          </Typography>
          <ExpandMoreIcon color="primary" fontSize="small" />
        </Box>
      </Stack>
      {isExpandFilter && (
        <Stack
          spacing={1}
          sx={{ border: 1, borderColor: '#E0E0E0', p: 1, borderRadius: '8px' }}
        >
          <Stack spacing={0.5}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              Includes
            </Typography>
            <CustomAutocomplete
              multiple
              id="keyword-includes"
              size="small"
              options={[]}
              defaultValue={[]}
              freeSolo
              value={values.includes}
              renderTags={(values: Array<any>, getTagProps) =>
                values.map((option: string, index: number) => (
                  <Chip
                    key={`${option}-${index}-includes`}
                    variant="outlined"
                    label={<Typography>{option}</Typography>}
                    size="small"
                    {...getTagProps({ index })}
                  />
                ))
              }
              onChange={(_e, value) => {
                handleIncludesLocal(value);
              }}
              forcePopupIcon={false}
              disableClearable
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="includes"
                  variant="outlined"
                  size="small"
                  autoComplete="off"
                  placeholder="Separated by Enter"
                  error={
                    touched.includes &&
                    Boolean(errors.includes) &&
                    values.includes &&
                    values.includes.length > 0
                  }
                  onPaste={(event) => {
                    const includes = event.clipboardData.getData('text');
                    const splitKeyword = includes.split(',');
                    const trimAndFilterKeyword = splitKeyword
                      .filter((word) => word.trim().length > 1)
                      .map((word) => word.trim());
                    const value = [...values.includes, ...trimAndFilterKeyword];
                    handleIncludesLocal(value);
                  }}
                />
              )}
            />
            <FormHelperText
              error
              variant="outlined"
              margin="dense"
              sx={{ ml: 0 }}
            >
              {errors.includes &&
                values.includes &&
                values.includes.length > 0 &&
                new Set(errors.includes)}
            </FormHelperText>
            <Stack direction="row" alignItems="center" spacing={1}>
              <InfoFilledIcon sx={{ fontSize: '14px' }} />
              <Typography color="#757575" fontSize="12px">
                Result must containt “Cat” or “Dog”.
              </Typography>
            </Stack>
          </Stack>
          <Stack spacing={0.5}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              Excludes
            </Typography>
            <CustomAutocomplete
              multiple
              id="keyword-excludes"
              size="small"
              options={[]}
              defaultValue={[]}
              freeSolo
              value={values.excludes}
              renderTags={(values: Array<any>, getTagProps) =>
                values.map((option: string, index: number) => (
                  <Chip
                    key={`${option}-${index}-excludes`}
                    variant="outlined"
                    label={<Typography>{option}</Typography>}
                    size="small"
                    {...getTagProps({ index })}
                  />
                ))
              }
              onChange={(_e, value) => {
                handleExcludesLocal(value);
              }}
              forcePopupIcon={false}
              disableClearable
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="excludes"
                  variant="outlined"
                  size="small"
                  autoComplete="off"
                  placeholder="Separated by Enter"
                  error={
                    touched.excludes &&
                    values.excludes &&
                    values.excludes.length > 0 &&
                    Boolean(errors.excludes)
                  }
                  onPaste={(event) => {
                    const excludes = event.clipboardData.getData('text');
                    const splitKeyword = excludes.split(',');
                    const trimAndFilterKeyword = splitKeyword
                      .filter((word) => word.trim().length > 1)
                      .map((word) => word.trim());
                    const value = [...values.excludes, ...trimAndFilterKeyword];
                    handleExcludesLocal(value);
                  }}
                />
              )}
            />
            <FormHelperText
              error
              variant="outlined"
              margin="dense"
              sx={{ ml: 0 }}
            >
              {errors.excludes &&
                values.excludes &&
                values.excludes.length > 0 &&
                new Set(errors.excludes)}
            </FormHelperText>
            <Stack direction="row" alignItems="center" spacing={1}>
              <InfoFilledIcon sx={{ fontSize: '14px' }} />
              <Typography color="#757575" fontSize="12px">
                Result won’t contain “Bird” or “Bee”.
              </Typography>
            </Stack>
          </Stack>
          <Stack>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              Languages
            </Typography>
            <FormControl size="small" fullWidth sx={{ mt: theme.spacing(1) }}>
              <Select
                id="languages"
                name="languages"
                value={values.languages}
                onChange={handleChange}
              >
                {languages.map(({ label, value }) => (
                  <MenuItem key={value} id={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Stack>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: 1
        }}
      >
        <Button variant="outlined" onClick={handleClear}>
          Clear
        </Button>
        <Button
          variant="contained"
          disabled={
            isDisableSubmit ||
            Boolean(errors.objectName) ||
            Boolean(
              errors.includes && values.includes && values.includes.length > 0
            ) ||
            Boolean(
              errors.excludes && values.excludes && values.excludes.length > 0
            )
          }
          onClick={handleSaveKeywordHashtag}
        >
          + Add
        </Button>
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right'
        }}
      >
        <List>
          <ListItem
            disablePadding
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            <Checkbox
              checked={socialMedia.length === listOptionSocialMedia.length}
              onChange={() => {
                if (socialMedia.length === listOptionSocialMedia.length) {
                  setSocialMedia([]);
                } else {
                  setSocialMedia(defaultSocmed);
                }
              }}
            />
            <Typography>All</Typography>
          </ListItem>
          {listOptionSocialMedia.map((socmed) => (
            <ListItem
              disablePadding
              key={socmed.id}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}
            >
              <>
                <Checkbox
                  checked={socialMedia.includes(socmed.id)}
                  onChange={() => {
                    if (socialMedia.includes(socmed.id)) {
                      setSocialMedia(
                        socialMedia.filter((item) => item !== socmed.id)
                      );
                    } else {
                      setSocialMedia([...socialMedia, socmed.id]);
                    }
                  }}
                />
                <socmed.icon />
                <Typography>{socmed.label}</Typography>
              </>
            </ListItem>
          ))}
        </List>
      </Popover>
    </Box>
  );
};

export default AddKeywordOrHastagRetail;
